// extracted by mini-css-extract-plugin
module.exports = {"error":"omf-calculate-test-form_error_i5ea4","spinnerWrapper":"omf-calculate-test-form_spinnerWrapper_3qiFm","spinner":"omf-calculate-test-form_spinner_2QIhf"};